// extracted by mini-css-extract-plugin
export var actions = "_46-0";
export var actionsContainer = "_46-6";
export var border = "_46-1";
export var childFullHeight = "_46-d";
export var collapse = "_46-2";
export var content = "_46-8";
export var contentChild = "_46-c";
export var fullscreen = "_46-a";
export var headerContainer = "_46-3";
export var headerRow = "_46-5";
export var hidePadding = "_46-9";
export var noScrollX = "_46-e";
export var noScrollY = "_46-f";
export var optOutTopPadding = "_46-b";
export var pagePadding = "_46-7";
export var profile = "_46-g";
export var profileContainer = "_46-h";
export var profileImage = "_46-i";
export var profileMain = "_46-j";
export var profileSubtitle = "_46-l";
export var profileTitle = "_46-k";
export var tabsWrapper = "_46-4";
export var title = "_46-m";